// extracted by mini-css-extract-plugin
export default {"container":"itemDetailsTab_container__GTg6F","leftSide":"itemDetailsTab_leftSide__uC3Le","rightSide":"itemDetailsTab_rightSide__TazaG"};